import React, { FC } from 'react';
import styled from 'styled-components';
import { InfoVideoBox } from 'components/InfoVideoBox/InfoVideoBox';
import { translate, translationKeys } from 'logic/translations/translations.service';

const StyledSection = styled.section`
  max-width: 100%;
  margin-left: auto;
  margin-right: auto;
`;

export const OnlineTutorDetailSectionPromotion: FC = () => {

  const infoVideoBoxText = {
    headline: translate(translationKeys.infoVideoBox.onlineTutoringPromotionDetailsPage.headline),
    subheadline: translate(translationKeys.infoVideoBox.onlineTutoringPromotionDetailsPage.subheadline),
    infoText: translate(translationKeys.infoVideoBox.onlineTutoringPromotionDetailsPage.infoText),
    buttonText: translate(translationKeys.infoVideoBox.onlineTutoringPromotionDetailsPage.buttonText),
  };

  return (
    <StyledSection>
      <InfoVideoBox videoID={'545088293'} text={infoVideoBoxText}/>
    </StyledSection>
  );
};
